import pythonApiClient from './pythonBaseApi';

/**
 * Historial de hospedaje por DNI (check-in, check-out, habitación).
 * GET /consultas/hoteleria/historial-huesped?dni=...
 */
const consultaHistorialHuespedApi = {
  consultarPorDni: async (dni, proyectoId) => {
    const response = await pythonApiClient.get(
      '/consultas/hoteleria/historial-huesped',
      {
        params: { dni: String(dni).trim() },
        headers: { 'X-Proyecto-ID': proyectoId },
      }
    );
    return response.data;
  },
};

export default consultaHistorialHuespedApi;
